import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const SectorizationByNeighborhoodMonthly = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Resultado das ocorrências mensais por região'}
            horizontal={false}
            subtitles={chartData?.sectorizationByNeighborhoodMonthly?.categories}
            series={chartData?.sectorizationByNeighborhoodMonthly?.series}
        />
    );
};